export default Object.freeze({
  Monthly: 1,
  Weekly: 2,
  Manual: 3,
  Immediate: 4,
});
